module.exports = __webpack_public_path__ + "assets/images/template/project/flu_comparison/mobile.svg?v=f276ee87";